module.exports = __webpack_public_path__ + "static/img/2_1_2.8f86d3a7.jpg";